import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

const currentDate = new Date();
const oneWeekLater = new Date(currentDate.getTime() + 7 * 24 * 60 * 60 * 1000);

export default class extends Controller {
  static targets = ["label", "input"];
  static values = {
    mode: { type: String, default: "single" },
    minDate: { type: String, default: "today" },
    dateFormat: { type: String, default: "Y-m-d" },
    range: {
      type: Array,
      default: [currentDate, oneWeekLater],
    },
    defaultToToday: { type: Boolean, default: true },
  };

  connect() {
    // Parse the rangeValue if passed otherwise fallback to defaults (today + 1.week)
    // Add to data-controller wrapper data-date-range-picker-range-value='["2023-11-18", "2023-11-25"]' =>
    this.rangeValue = this.rangeValue.map((dateString) => new Date(dateString));

    console.log(this.inputTarget.value.toString());

    let self = this;
    const picker = flatpickr(this.element, {
      mode: this.modeValue,
      minDate: this.minDateValue,
      dateFormat: this.dateFormatValue,
      defaultDate:
        new Date(Date.parse(this.inputTarget.value)) ||
        (this.defaultToTodayValue ? new Date() : undefined),
      onChange: function (selectedDates, dateStr, instance) {
        self.setCurrentRange(instance);
      },
    });

    this.setCurrentRange(picker);
  }

  setCurrentRange(picker) {
    const formatDate = (date) => {
      const options = { month: "short", day: "numeric", year: "numeric" };
      return date.toLocaleDateString("en-ZW", options);
    };

    const range = picker.selectedDates.map(formatDate).join(" - ");

    if (this.hasLabelTarget && range.length > 0) {
      this.labelTarget.textContent = range;

      // Update formatting to match your data type needs
      // See: https://flatpickr.js.org/options/
      this.inputTarget.value = picker.selectedDates
        .map((date) => {
          return date.toLocaleDateString("en-ZW", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          });
        })
        .join(" - ");
    }

    // Do something with the server to return dates
  }
}
